import { render, staticRenderFns } from "./permission-edit.vue?vue&type=template&id=54db4ad9&scoped=true"
import script from "./permission-edit.vue?vue&type=script&lang=ts"
export * from "./permission-edit.vue?vue&type=script&lang=ts"
import style0 from "./permission-edit.vue?vue&type=style&index=0&id=54db4ad9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54db4ad9",
  null
  
)

export default component.exports